import React from "react";

interface StarGroupProps {
  width?: number;
  height?: number;
  className?: string;
  stroke?: string;
}

const StarGroup: React.FC<StarGroupProps> = ({ width = 24, height = 24, className, stroke = "#008CFF" }) => {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.91211 20.1172V16.0586M5.91211 7.94141V3.88281M3.88281 5.91211H7.94141M3.88281 18.0879H7.94141M12.8117 4.69453L11.4041 8.35446C11.1751 8.94964 11.0607 9.24722 10.8827 9.49754C10.7249 9.71939 10.5311 9.91323 10.3093 10.071C10.0589 10.249 9.76135 10.3634 9.16618 10.5923L5.50625 12L9.16618 13.4077C9.76135 13.6366 10.0589 13.751 10.3093 13.929C10.5311 14.0868 10.7249 14.2806 10.8827 14.5025C11.0607 14.7528 11.1751 15.0504 11.4041 15.6455L12.8117 19.3055L14.2194 15.6455C14.4483 15.0504 14.5628 14.7528 14.7407 14.5025C14.8985 14.2806 15.0923 14.0868 15.3142 13.929C15.5645 13.751 15.8621 13.6366 16.4573 13.4077L20.1172 12L16.4573 10.5923C15.8621 10.3634 15.5645 10.249 15.3142 10.071C15.0923 9.91323 14.8985 9.71939 14.7407 9.49754C14.5628 9.24722 14.4483 8.94964 14.2194 8.35446L12.8117 4.69453Z"
      />
    </svg>
  )
}

export default StarGroup;
